import React from 'react';
import bugsnag, { Bugsnag } from '@bugsnag/browser';
import bugsnagReact from '@bugsnag/plugin-react';

let shippitBugsnag: Bugsnag.Client;
export default function createBugSnagger() {
  shippitBugsnag = bugsnag({
    apiKey: process.env.REACT_APP_BUGSNAG_API_KEY || 'invalidkey',
    releaseStage: process.env.REACT_APP_API_DOMAIN || 'development',
    notifyReleaseStages: ['production', 'staging'],
  });
  shippitBugsnag.use(bugsnagReact, React);
  return shippitBugsnag.getPlugin('react');
}

export function getBugSnagger() {
  return shippitBugsnag;
}
